// Feature flags gated behind REACT_APP_* environment variables.

// AdSense is disabled by default until it is ready to be re-enabled.
export const isAdsEnabled = (): boolean => process.env.REACT_APP_ENABLE_ADS === 'true';
